import initListBox from './collapsible-listbox';
import EventEmitter from "../event-emitter";
import DOMHelper from "../../../../lib/dom-helper";

export default class Select {
    constructor(props = {}) {
        this.props = props;

        this.$root = props.$root;

        this._listboxController = null;
        this._eventEmitter = new EventEmitter(this.props.subscriptions || []);
        this._value = null;

        this.VALUE_CHANGE_EVENT = 'valueChange';

        this.init();
    }

    init() {
        this._checkProps();
        this._initComponents();
        this._addSubscriptions();
    }

    getValue() {
        return this._value;
    }

    _checkProps() {
        if (!this.$root) {
            throw new Error('Select: Root element is not defined!');
        }
    }

    _initComponents() {
        this._listboxController = initListBox(this.$root);
    }

    _addSubscriptions() {
        this._listboxController.listbox.$root.addEventListener('select', this._handleSelect.bind(this));
    }

    _handleSelect() {
        this._value = this._listboxController.listbox.$root.dataset.selected;
        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this._value);
    }

    setButtonDisabled(disabled) {
        if (disabled) {
            this._listboxController.listboxButton.$root.classList.add('-disabled');
            this._listboxController.listboxButton.$root.setAttribute('disabled', true);
            return;
        }

        this._listboxController.listboxButton.$root.classList.remove('-disabled');
        this._listboxController.listboxButton.$root.removeAttribute('disabled');
    }

    setInitialState() {
        this._listboxController.listbox.unselectActive();
        this._listboxController.listboxButton.setInitialContent();
        this._value = null;
        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this._value);
    }

    importOptions(options) {
        if (Array.isArray(options)) {
            options.forEach((option) => {
                if (option instanceof HTMLElement) {
                    this._listboxController.listbox.$listboxOpts.append(option);
                }
            });
        } else if (typeof options === 'string') {
            this._listboxController.listbox.$listboxOpts.innerHTML = options.trim();
        }
    }

    addOptions(data) {
        if (!Array.isArray(data)) {
            throw new TypeError('Select: Data must be an array of objects with label, value props.');
        }

        data.forEach((item) => {
            if (typeof item.label === 'undefined' || typeof item.value === 'undefined') {
                throw new Error('Select: Label or value props is not defined.');
            }

            this.addOption(item.label, item.value);
        });
    }

    addOption(label, value) {
        if (typeof label === 'undefined' || typeof value === 'undefined') {
            throw new Error('Select: Label or value is not defined.');
        }

        this._listboxController.listbox.$listboxOpts.append(Select.createOption(label, value));
    }

    selectFirstOption() {
        const $firstOption = this._listboxController.listbox.$listboxOpts.querySelector('.listbox_option');

        if ($firstOption) {
            this._listboxController.listbox.selectOption($firstOption);
        }
    }

    selectLastOption() {
        const $lastOption = this._listboxController.listbox.$listboxOpts.querySelector('.listbox_option:last-child');

        if ($lastOption) {
            this._listboxController.listbox.selectOption($lastOption);
        }
    }

    selectOptionByValue(value) {
        const $option = this._listboxController.listbox.$listboxOpts.querySelector(`[data-value="${value}"]`);

        if ($option) {
            this._listboxController.listbox.selectOption($option);
        }
    }

    static createOption(label, value) {
        if (typeof label === 'undefined' || typeof value === 'undefined') {
            return null;
        }

        return DOMHelper.createElement('li', {
            text: label,
            attributes: {
                class: 'listbox_option',
                'data-value': value,
                role: 'option'
            }
        });
    }
}